import React from "react";

interface LoaderProps {
  message: string;
}

export const Loader: React.FC<LoaderProps> = ({ message }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-8">
      <div className="relative w-16 h-16 flex items-center justify-center">
        <div className="text-4xl animate-pulse-heart">❤️</div>
      </div>
      <p className="text-center text-mutedGray dark:text-gray-400 text-lg">
        {message}
      </p>
    </div>
  );
};
